import type { Signer } from '@/types'

type StateSignaturesConfig = Record<
	string,
	{
		[key in Signer]?: boolean
	}
>
export const statesSignaturesConfig: StateSignaturesConfig = {
	AL: {
		FuneralDirector: false,
	},
	AK: {
		FuneralDirector: false,
	},
	AZ: {
		FuneralDirector: false,
	},
	AR: {
		FuneralDirector: false,
	},
	CA: {
		FuneralDirector: false,
	},
	CO: {
		FuneralDirector: false,
	},
	CT: {
		FuneralDirector: false,
	},
	DC: {
		FuneralDirector: false,
	},
	DE: {
		FuneralDirector: false,
	},
	FL: {
		FuneralDirector: false,
	},
	GA: {
		FuneralDirector: false,
	},
	HI: {
		FuneralDirector: false,
	},
	ID: {
		FuneralDirector: false,
	},
	IL: {
		FuneralDirector: false,
	},
	IN: {
		FuneralDirector: false,
	},
	IA: {
		FuneralDirector: false,
	},
	KS: {
		FuneralDirector: false,
	},
	KY: {
		FuneralDirector: false,
	},
	LA: {
		FuneralDirector: false,
	},
	ME: {
		FuneralDirector: false,
	},
	MD: {
		FuneralDirector: false,
	},
	MA: {
		FuneralDirector: false,
	},
	MI: {
		FuneralDirector: false,
	},
	MN: {
		FuneralDirector: false,
	},
	MS: {
		FuneralDirector: false,
	},
	MO: {
		FuneralDirector: false,
	},
	MT: {
		FuneralDirector: false,
	},
	NE: {
		FuneralDirector: false,
	},
	NV: {
		FuneralDirector: false,
	},
	NH: {
		FuneralDirector: false,
	},
	NJ: {
		FuneralDirector: false,
	},
	NM: {
		FuneralDirector: false,
	},
	NY: {
		FuneralDirector: false,
	},
	NC: {
		FuneralDirector: false,
	},
	ND: {
		FuneralDirector: false,
	},
	OH: {
		FuneralDirector: true,
	},
	OK: {
		FuneralDirector: false,
	},
	OR: {
		FuneralDirector: false,
	},
	PA: {
		FuneralDirector: true,
	},
	RI: {
		FuneralDirector: false,
	},
	SC: {
		FuneralDirector: false,
	},
	SD: {
		FuneralDirector: false,
	},
	TN: {
		FuneralDirector: false,
	},
	TX: {
		FuneralDirector: true,
	},
	UT: {
		FuneralDirector: false,
	},
	VT: {
		FuneralDirector: false,
	},
	VA: {
		FuneralDirector: false,
	},
	WA: {
		FuneralDirector: false,
	},
	WV: {
		FuneralDirector: true,
	},
	WI: {
		FuneralDirector: false,
	},
	WY: {
		FuneralDirector: false,
	},
}

export const stateRequiresSignature = (
	state: keyof StateSignaturesConfig | undefined,
	signer: Signer
): boolean => {
	if (!state) {
		return true
	}
	return statesSignaturesConfig[state][signer] ?? true
}
